import PubSub from 'services/PubSub/';
import AccountInfo from 'services/AccountInfo/';
import AddressService from 'services/Address/';
import OrdersService from 'services/Orders/';
import StorageService from 'services/StorageService/';
import CartActions from 'actions/Cart';
import CmsService from 'services/CMS'

const verifyPersistentOrderForm = (data, callbackLogin, closeLogin = () => {}, urlCallback = false) => {
    const {user} = data;
    const currentTime = new Date().getTime();
    const orderFormIdJumbocl = user.orderFormIdJumbocl;

    if(orderFormIdJumbocl && orderFormIdJumbocl.id && (orderFormIdJumbocl.create) >= (currentTime - (1000*60*60*24))) {

        OrdersService.getLastOrder(data.token).then(data => {

            const orderFormId = data && data.data ? data.data.orderFormId  : false;

            if(orderFormId !== orderFormIdJumbocl.id) {

                const storageOrderFormId = StorageService.getItem('orderFormId');

                if(storageOrderFormId !== orderFormIdJumbocl.id){

                    closeLogin();

                    PubSub.dispatch('modal_confirmation_open', {
                        message: "<span class='text'>En tu carro hay productos ingresados desde otro dispositivo <br/>¿Qué quieres hacer con ellos?</span>",
                        cancelBtnText: 'Eliminarlos',
                        confirmBtnText: 'Mantenerlos',
                        confirmCallback: () => {
                            setTimeout(() => {
                                AddressService.clearAnonymousAdresses();
                                callbackLogin(false);
                                applyPersistentOrderForm(true, user, urlCallback);
                            },0)
                        },
                        cancelCallback: () => {
                            setTimeout(() => {
                                callbackLogin();
                                setTimeout(() => {
                                    applyLastShippingAddress();
                                    if(urlCallback) window.location.href = urlCallback;

                                },100)
                            },0)

                        }
                    });

                } else {
                    CartActions.getCart();
                    callbackLogin();
                }

            } else {
                callbackLogin();
            }
        });
    } else {
        callbackLogin();
        applyLastShippingAddress();
        _setPersistentOrderForm(currentTime);
    }
}

const applyLastShippingAddress = () => {
    let shippingAddress = StorageService.getSecureItem('userData');
    let address = shippingAddress.last_shipping_address && shippingAddress.last_shipping_address.content;
    let selectedSla = shippingAddress.last_shipping_address && shippingAddress.last_shipping_address.selectedSla;
    let friendlyName = shippingAddress.last_shipping_address && shippingAddress.last_shipping_address.content.logisticsInfo;

    if(selectedSla){
        if (selectedSla.indexOf('Click al Auto') !== -1 || selectedSla.indexOf('Retiro en Tienda') !== -1) {
            let typeMethod = selectedSla;
            let treatmentTypeMethod = typeMethod.split('(').shift();
            CmsService.getOperationsV2().then((data) => {
                let stores = data && data.store;
                let matchStore = _getStore(stores, friendlyName);
                if(matchStore && matchStore.sc){
                    let sc = matchStore && matchStore.sc;
                    let storeName = matchStore.name;
                    _applyDelivery(sc, trasnlateMethod(treatmentTypeMethod), storeName, treatmentTypeMethod, false)
                }
            })

        } else if (selectedSla.indexOf('Despacho a Domicilio') !==-1 || (selectedSla.indexOf('Despacho Express') !==-1)){
            AddressService.getSalesChannel(address.geoCoordinates[1], address.geoCoordinates[0]).then(salesChannel => {
                if (salesChannel.sc) {
                    let sc = salesChannel.sc;
                    address.geoCoordinate = address.geoCoordinates;
                    _applyDelivery(sc, trasnlateMethod(selectedSla), address.neighborhood, selectedSla, address);

                }
            });
        }
    }
}


const _getStore = (stores, friendlyName) => {
    if (!stores) return false;
    return stores.find(store => store.value === friendlyName);
}

const trasnlateMethod = (method) => {

    switch(method){
        case 'Click al Auto':
            return "seller-1-sla-ClickalAuto";
        case 'Retiro en Tienda':
            return "seller-1-sla-RetiroenTienda";
        case 'Despacho a Domicilio':
            return "seller-1-sla-DespachoaDomicilio";
        case 'seller-1-sla-Express':
            return 'Despacho Express';
        default:
            return '';
    }
}

const _applyDelivery = (sc, method, name, nameMethod, selectedAddress = null, simulation = true) =>{

    const responsePromise = {
        data: {
            isDisponible: true
        }
    }

    let consult = simulation ? AddressService.getLogisticSimulation(selectedAddress, sc, nameMethod) : Promise.resolve(responsePromise);

    return consult.then(data => {
        if(data.data && data.data.isDisponible) {
            return AddressService.newSetDeliveryMode(method, name, sc, true, selectedAddress).then((orderForm) => {
                return orderForm;
            });
        }
    })
}

const _setPersistentOrderForm = (currentTime) => {
    const orderFormId = StorageService.getItem('orderFormId');
    const data = {
        id: orderFormId,
        create: currentTime,
        delivery: null
    }

    AccountInfo.updtePersistentOrderForm(data);
}

const applyPersistentOrderForm = (active, user, urlCallback = false) => {

    if(!active) return false;

    let storeName = '';

    const orderFormIdJumbocl = user.orderFormIdJumbocl;

    StorageService.setItem('orderFormId', orderFormIdJumbocl.id);

    CartActions.getCart().then(orderForm => {

        const shippingData = orderForm.shippingData

        if(shippingData.address !== null) {

            if(shippingData.address.addressId){
                StorageService.setItem('addressSelected', shippingData.address.addressId);
            }

            StorageService.setSecureItem('address', shippingData.address);

            const methodTranslate = {
                1 : 'seller-1-sla-DespachoaDomicilio',
                2 : 'seller-1-sla-RetiroenTienda',
                3 : 'seller-1-sla-ClickalAuto',
                4 : 'seller-1-sla-Express'
            }

            if((orderFormIdJumbocl.delivery !== 1) && (orderFormIdJumbocl.delivery !== 4)) {
                storeName = shippingData.pickupPoints ? shippingData.pickupPoints[0].friendlyName : '';
            } else {
                storeName = shippingData.address.neighborhood;
            }

            AddressService.setDeliveryMode(methodTranslate[orderFormIdJumbocl.delivery], storeName, orderForm.salesChannel, false, false, urlCallback)
        }

        if(window) {
            if(urlCallback) window.location.href = urlCallback;
            else window.location.reload();
        }
    });
}

const PersistentCart = {
    verifyPersistentOrderForm
}

export default PersistentCart;
